import { Store } from 'store/index';
import { ProductRecommendationSlot } from '../types';

const getProductRecommendationByKey = (key: ProductRecommendationSlot) => (store: Store) =>
  store.product.productRecommendations[key];

export default getProductRecommendationByKey;
